import {
  SET_CARDS,
  LOAD_CARDS,
  LOAD_CARD_TEMPLATES,
  SET_CARD_TEMPLATES,
  ADD_NEW_CARD_TEMPLATE,
  REMOVE_CARD_TEMPLATE,
  UPDATE_CARD_TEMPLATE,
  RESET_CARD_TEMPLATES_STATE,
  TEMPLATE_PAGINATION,
  TEMPLATE_SAVING
} from '../mutationTypes'
import api, { getData } from '@/axiosConfig'
import { status, compare } from '../../helpers'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'
import router from '@/router'

export default {
  async getCards({ commit, dispatch }) {
    try {
      commit(LOAD_CARDS, status.LOADING)
      const response = await gemnoteAPI.get('team/cards')
      const data = getData(response)

      // create a new array from the productVariantsList.data array of each card in the cardList array
      const cardList = []
      data.forEach(element => {
        const item =
          element.attributes &&
          element.attributes.productVariantsList &&
          element.attributes.productVariantsList.data

        if (item) {
          item.forEach(variant => {
            const newVariant = {
              id: variant.id,
              attributes: {
                ...variant.attributes,
                tagList: element.attributes && element.attributes.tagList,
                typeList: element.attributes && element.attributes.typeList
              },
              image:
                (variant.attributes && variant.attributes.images[0]) ||
                (variant.attributes &&
                  variant.attributes.representativeImages[0]),
              inventoryCount:
                variant.attributes && variant.attributes.availableInventoryCount
            }
            cardList.push(newVariant)
          })
        }
      })

      commit(SET_CARDS, cardList.sort(compare))
      commit(LOAD_CARDS, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_CARDS, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('cards.action.get-cards-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getCardTemplates({ commit, dispatch }, { page, perPage }) {
    try {
      commit(LOAD_CARD_TEMPLATES, status.LOADING)
      const response = await gemnoteAPI.get(
        `team/card_templates?page[number]=${page}&page[size]=${perPage}`
      )
      const { totalCount } = response.data.meta
      const data = getData(response)
      let templateList = data.map(template => {
        return {
          id: template.id,
          name: template.attributes.name,
          message: template.attributes.message,
          createdAt: template.attributes.createdAt,
          createdById: template.relationships.createdBy.data.id,
          createdByEmail: template.attributes.createdByUser.email
            ? template.attributes.createdByUser.email
            : ''
        }
      })
      commit(TEMPLATE_PAGINATION, totalCount)
      commit(LOAD_CARD_TEMPLATES, status.LOADED)
      commit(SET_CARD_TEMPLATES, templateList.sort(compare))
    } catch (error) {
      console.log(error)
      commit(LOAD_CARD_TEMPLATES, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('templates.action.get-templates-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addCardTemplate({ commit, dispatch, rootState }, cardTemplateObject) {
    try {
      commit(TEMPLATE_SAVING, true)
      let { name, message } = cardTemplateObject
      const route =
        router &&
        router.history &&
        router.history.current &&
        router.history.current.path
      const isManageTemplate = route.includes('manage-templates')

      let errors = []
      if (!name) {
        errors.push(i18n.t('validations.blank-template-name'))
      }

      if (!message) {
        errors.push(i18n.t('validations.blank-template-body'))
      }

      if (errors.length) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        return
      }

      if (!rootState.team.id) {
        await dispatch('team/getTeam', {}, { root: true })
      }

      let cardBody = {
        card_template: {
          name,
          message,
          created_by_id: rootState.profile.user.id,
          team_id: rootState.team.team.id
        }
      }
      const response = await gemnoteAPI.post('team/card_templates', cardBody)
      const data = getData(response)
      let newTemplate = {
        id: data.id,
        name,
        message
      }

      if (isManageTemplate) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [`${newTemplate.name} has been successfully created.`]
          },
          { root: true }
        )

        router.push('/manage-templates')
      }

      commit(TEMPLATE_SAVING, false)
      commit(ADD_NEW_CARD_TEMPLATE, newTemplate)

      // dispatch('order/setCardMessage', '', { root: true })
      dispatch('order/setSelectedTemplate', data.id, { root: true })
      dispatch('groupOrder/setSelectedTemplate', data.id, { root: true })
      dispatch('modal/hideModal', {}, { root: true })
    } catch (error) {
      commit(TEMPLATE_SAVING, false)
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('templates.action.create-template-error')]
          },
          { root: true }
        )
      }
    }
  },
  async removeCardTemplate({ commit, dispatch }, templateId) {
    try {
      await gemnoteAPI.delete(`team/card_templates/${templateId}`)
      commit(REMOVE_CARD_TEMPLATE, templateId)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('templates.action.template-removed-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('templates.action.template-removed-error')]
          },
          { root: true }
        )
      }
    }
  },
  async updateCardTemplate(
    { commit, dispatch, rootState },
    cardTemplateObject
  ) {
    try {
      let { id, name, message } = cardTemplateObject
      let cardBody = {
        card_template: {
          name,
          message
        }
      }
      await gemnoteAPI.put(`team/card_templates/${id}`, cardBody)
      commit(UPDATE_CARD_TEMPLATE, cardTemplateObject)

      if (rootState.order.selectedTemplateId === id) {
        dispatch('order/setCardMessage', message, { root: true })
      }

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('templates.action.template-update-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { message } = error.response.data.errors[0]

          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('templates.action.template-update-error')]
          },
          { root: true }
        )
      }
    }
  },
  resetCardTemplateState({ commit }) {
    commit(RESET_CARD_TEMPLATES_STATE)
  }
}
